import { __assign, __generator, __spreadArrays } from "tslib";
import { all, takeEvery, select, put, call } from 'redux-saga/effects';
import { request } from '../../xhr';
import { beginAwardBadgeFlow, awardBadge, awardBadgeFail, awardBadgeSuccess, fetchAvailableBadges, fetchAvailableBadgesSuccess, fetchBadgeGiverStreamNext, } from './actionCreators';
import { pushModal, removeModalsOfType } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { setWatchingState } from '../../WatchButton/redux/actionCreators';
import { withOffset, selectors as streamSelectors } from '../../Stream';
function getFakeStreamData() {
    if (process.env.NODE_ENV !== 'production') {
        var users = require('@wix/da-sample-data').users; // eslint-disable-line global-require
        var Chance = require('chance').Chance; // eslint-disable-line global-require
        var chance_1 = new Chance();
        return {
            hasMore: false,
            nextOffset: null,
            results: chance_1.pickset(users, 20).map(function (user) { return (__assign(__assign({}, user), { isWatching: chance_1.bool(), profile: { tagline: chance_1.bool() ? chance_1.sentence() : '' } })); }),
        };
    }
    return false;
}
function handleBeginAwardBadgeFlow(action) {
    var recipient;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                recipient = action.payload.recipient;
                return [4 /*yield*/, put(pushModal(ModalType.AWARD_BADGE, {
                        params: { recipient: recipient },
                        wrapInPopup: false,
                    }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleAwardBadge(action) {
    var _a, badgeType, recipient, data, result, newBalance;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, badgeType = _a.badgeType, recipient = _a.recipient;
                data = {
                    badgetype: badgeType,
                    typeid: recipient.typeId,
                    itemid: recipient.itemId,
                    userid: recipient.user.userId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'corebadge/award',
                        data: data,
                    })];
            case 1:
                result = _b.sent();
                // Close the modal first
                return [4 /*yield*/, put(removeModalsOfType(ModalType.AWARD_BADGE))];
            case 2:
                // Close the modal first
                _b.sent();
                if (!(result && result.badge)) return [3 /*break*/, 4];
                newBalance = result.balance;
                return [4 /*yield*/, put(awardBadgeSuccess(result.badge, recipient, newBalance))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(awardBadgeFail(badgeType, recipient))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function handleFetchAvailableBadges(action) {
    var userId, params, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                userId = action.payload.userId;
                params = { userid: userId };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'corebadge/available_badges',
                        params: params,
                    })];
            case 1:
                result = _a.sent();
                if (!result) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchAvailableBadgesSuccess(userId, result.results))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
function handleStreamFetch(action) {
    var streamId, streamParams, _a, offset, limit, recipient, params, result, hasMore, nextOffset, results;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                streamId = action.payload.streamId;
                return [4 /*yield*/, select(streamSelectors.getStreamParams, streamId)];
            case 1:
                streamParams = _b.sent();
                return [4 /*yield*/, select(function (state) { return ({
                        offset: withOffset.selectors.getNextOffset(state, streamId),
                        limit: streamSelectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 2:
                _a = _b.sent(), offset = _a.offset, limit = _a.limit;
                recipient = streamParams.recipient;
                params = {
                    badgetype: streamParams.type,
                    typeid: recipient.typeId,
                    itemid: recipient.itemId,
                    userid: recipient.user.userId,
                    offset: offset,
                    limit: limit,
                };
                return [4 /*yield*/, call(request, { method: 'get', url: 'corebadge/givers', params: params }, getFakeStreamData)];
            case 3:
                result = _b.sent();
                if (!result) return [3 /*break*/, 5];
                hasMore = result.hasMore, nextOffset = result.nextOffset, results = result.results;
                return [4 /*yield*/, all(__spreadArrays(results.map(function (user) { var _a; return put(setWatchingState(user.username, (_a = user.isWatching) !== null && _a !== void 0 ? _a : false)); }), [
                        put(withOffset.actions.fetchSuccess({
                            streamId: streamId,
                            hasMore: !!hasMore,
                            nextOffset: nextOffset !== null && nextOffset !== void 0 ? nextOffset : undefined,
                            items: results,
                        })),
                    ]))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(beginAwardBadgeFlow, handleBeginAwardBadgeFlow),
                    takeEvery(awardBadge, handleAwardBadge),
                    takeEvery(fetchBadgeGiverStreamNext, handleStreamFetch),
                    takeEvery(fetchAvailableBadges, handleFetchAvailableBadges),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map